import { render, staticRenderFns } from "./DepositoList.vue?vue&type=template&id=f2bf5608&scoped=true"
import script from "./DepositoList.vue?vue&type=script&lang=js"
export * from "./DepositoList.vue?vue&type=script&lang=js"
import style0 from "./DepositoList.vue?vue&type=style&index=0&id=f2bf5608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bf5608",
  null
  
)

export default component.exports